import React from 'react'
import { memberMobx, payPlanMobx, thirdPartyMobx } from '@mobxStore'
import { cartMobx, discountMobx, feeMobx, storeMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { Discount, Tip } from '../../component'
import { BoxPriceModal, ExpressPriceModal } from '../../modal'
import { observer } from 'mobx-react'
import { CommonDetailModal } from '@cps'

interface IProps {

}

const CartResultPrice: React.FC<IProps> = ({ }) => {
  const { cartResult } = cartMobx

  const handleShowBoxPrice = () => {
    modalLayer(BoxPriceModal, {})
      .then(() => {})
      .catch(() => {})
  }
  const handleShowExpressPrice = () => {
    modalLayer(ExpressPriceModal, {})
      .then(() => {})
      .catch(() => {})
  }

  const showServiceChageDetail = () => {
    const datas = cartResult.serviceChargeDetail.map(item => {
      const value = item.type === 'amount' ? format.toPrice(item.value) : item.value.toString() + '%'
      return {
        id: item.id,
        name: item.name,
        price: item.amount,
        tips: i18n.t(`checkout.service_charge_by_${item.type === 'person' ? 'person' : 'fixed'}_${item.type === 'amount' ? 'amount' : 'percent'}`, { serviceCharge: feeMobx.gratuityConfig?.name, value })
      }
    })
    modalLayer(CommonDetailModal, { datas, title: feeMobx.gratuityConfig?.name }, 'commonDetailModal')
      .then(() => { })
      .catch(() => { })
  }

  return (
    // cartMobx.info.payMode === 0 && !cartMobx.needPack && (
    <>
      <div className='cart-box'>
        <div className='cart-box-info cart-box-item'>
          <div className='cart-item-left'>
            <p>{i18n.t('result.productPrice')}</p>
          </div>
          <p className='cart-item-price'>{format.toPrice(cartResult.itemPrice)}</p>
        </div>
        {
          cartResult.boxPrice > 0 ? (
            <div className='cart-box-info cart-box-item'>
              <div className='cart-item-left'>
                <p>{i18n.t('result.boxPrice')}</p>
                <i className='iconfont icon-question1' data-cypid='bt-cart-show-boxfee' onClick={handleShowBoxPrice}></i>
              </div>
              <div className='cart-item-price'>{format.toPrice(cartResult.boxPrice)}</div>
            </div>
          ) : null
        }
        {/* 配送费 */}
        {
          cartMobx.info.eatType === 'delivery' || cartResult.expressPrice > 0 ? (
            <div className='cart-box-info cart-box-item'>
              <div className='cart-item-left'>
                <p>{i18n.t('result.expressPrice')}</p>
                {cartMobx.info.expressList?.length > 1 && <i className='iconfont icon-question1' data-cypid='bt-cart-show-express' onClick={handleShowExpressPrice}></i>}
              </div>
              <div className='cart-item-price'>{format.toPrice(cartResult.expressPrice)}</div>
            </div>
          ) : null
        }
        <Discount />
        {
          window.bo !== 'cn' && (
            <div className='cart-box-info cart-box-item'>
              <div className='cart-item-left'>
                <p>{i18n.t('result.tax')}</p>
              </div>
              <div className='cart-item-price'>{format.toPrice(cartResult.tax || 0)}</div>
            </div>
          )
        }
        {/* 服务费 */}
        {
          cartResult.serviceCharge > 0 ? (
            <div className='cart-box-info cart-box-item'>
              <div className='cart-item-left'>
                <p>{feeMobx.gratuityConfig?.name}</p>
                <i className='iconfont icon-question1' data-cypid='bt-cart-show-service' onClick={showServiceChageDetail}></i>
              </div>
              <div className='cart-item-price'>{format.toPrice(cartResult.serviceCharge || 0)}</div>
            </div>
          ) : null
        }
        {
          boJudge.checkKey('hasTip') && !(Config.codeType === 'table' && !(storeMobx.storeSceneConfig?.openAfterPayCustomerPay || !storeMobx.storeSceneConfig?.payMode) && !payPlanMobx.tipAmount) ? <Tip /> : null
        }
      </div>
      <div className='cart-pay-result'>
        <div className='cart-pay-box'>
          <div className='cart-pay-info'>
            <div className='actual-pay-amount'>
              <span dangerouslySetInnerHTML={{ __html: i18n.t('cart.result', { totalCnt: cartResult.totalCnt, totalDiscountPrice: format.toPriceLittleCurrency(cartResult.totalDiscountPrice + thirdPartyMobx.couponResult.offPrice) }) }}></span>
              <span className='amount' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(payPlanMobx.totalAmount - thirdPartyMobx.couponResult.offPrice) }}></span>
            </div>
            {
              memberMobx.isLogin && memberMobx.cardInfo?.card?.isIntegral && <div className='integral'>{i18n.t('cart.maybeGetIntegral', { count: discountMobx.discountResult.getIntegral })}</div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(CartResultPrice)
